import PropTypes from 'prop-types'
import { createContext, useState, useEffect } from 'react'
import { toastErrorLog } from '../../helpers/toastErrorLog'
import * as carritoService from '../servicios/carritoService'
import * as imputacionService from '../servicios/imputacionService'

export const CarritoContext = createContext()

export const CarritoProvider = (props) => {
  const [cantidad, setCantidad] = useState(0)
  const [cantidadCompra, setCantidadCompra] = useState(1)
  const [verCarrito, setVerCarrito] = useState(false)
  const [items, setItems] = useState([])
  const [itemAgregado, setItemAgregado] = useState([])
  const [precioUnitario, setPrecioUnitario] = useState(0)

  const [idPresupuestoComprar, setIdPresupuestoComprar] = useState(0)
  const [idPublicacionComprar, setIdPublicacionComprar] = useState(0)

  const getCarrito = async () => {
    if (localStorage.getItem('idUsuario') && !isNaN(localStorage.getItem('idUsuario'))) {
      const { data: items } = await carritoService.buscarPorUsuario(
        parseInt(localStorage.getItem('idUsuario'))
      )

      setCantidad(items.length)
      setItems(items)
    }
  }

  const onAgregarCarrito = async (idPublicacion, cantidad) => {
    try {
      const carrito = {
        idPublicacion: idPublicacion,
        idUsuario: parseInt(localStorage.getItem('idUsuario')),
        cantidad: parseInt(cantidad),
        idEstado: 1
      }
      const { data: newItem } = await carritoService.insertar(carrito)

      if (newItem) {
        setItemAgregado(newItem)
        getCarrito()
      }
      return newItem
    } catch (error) {
      const mensaje = `Ocurrió un error al agregar el producto al carrito.`
      toastErrorLog(error, mensaje, 'carrito')
    }
  }

  const getImputacion = async () => {
    const jwt = localStorage.getItem('jwt')
    const empid = localStorage.getItem('empid')
    const usrProv = localStorage.getItem('usuario')
    if (empid && empid !== '' && jwt && jwt !== '' && usrProv && usrProv !== '') {
      const { data: centroDeCostos } = await imputacionService.imputacion(
        empid,
        usrProv,
        'ES',
        jwt
      )
      return centroDeCostos
    }
  }

  useEffect(() => {
    getCarrito()
  }, [])

  return (
    <CarritoContext.Provider
      value={{
        setCantidad,
        setVerCarrito,
        setItems,
        setIdPublicacionComprar,
        setIdPresupuestoComprar,
        onAgregarCarrito,
        getCarrito,
        setCantidadCompra,
        setPrecioUnitario,
        getImputacion,
        verCarrito,
        items,
        cantidad,
        itemAgregado,
        idPresupuestoComprar,
        idPublicacionComprar,
        cantidadCompra,
        precioUnitario
      }}
    >
      {props.children}
    </CarritoContext.Provider>
  )
}

CarritoProvider.propTypes = {
  children: PropTypes.node.isRequired
}
